import { useNavigation } from '@react-navigation/native';
import { useCallback } from 'react';

export const useNavigationGoBack = () => {
  const navigation = useNavigation();
  return useCallback(() => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }

    navigation.reset({
      routes: [
        {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-expect-error
          name: 'tab',
        },
      ],
    });
    console.log('돌아갈 화면이 없어요');
  }, [navigation]);
};
